import { FC, useMemo } from "react";
import { formatUAHStandard } from "tm-shared/utils";

import FlexContainer from "@/components/FlexContainer";
import { PrimaryText } from "@/components/Typography/Styled";
import { useAppSelector } from "@/hooks/redux";

import {
    DashboardCollapse,
    DashboardCollapseListItem,
} from "../components/DashboardCollapse";
import { DashboardErrorBlock } from "../components/DashboardErrorBlock";
import { StyledSalaryAmount } from "./Styled";

interface SalaryProps {
    targetDB: "db-sv" | "db-ta";
}

export const Salary: FC<SalaryProps> = ({ targetDB }) => {
    const workState = useAppSelector((state) => state.work);
    const svState = useAppSelector((state) => state.sv);
    const { salary, salaryError } = targetDB === "db-sv" ? svState : workState;

    const salaryDetails: DashboardCollapseListItem[] = useMemo(
        () => [
            {
                label: "Ставка:",
                value: `${formatUAHStandard(salary?.amountRate ?? 0)}`,
                type: "basic",
            },
            {
                label: "Бонуси:",
                value: `${formatUAHStandard(salary?.motivationBonus ?? 0)}`,
                type: "basic",
            },
            {
                label: "Бонус від MML:",
                value: `${formatUAHStandard(salary?.mmlBonus ?? 0)}`,
                type: "basic",
            },
        ],
        [salary],
    );

    if (!salaryError && !salary) return null;

    if (salaryError) {
        return <DashboardErrorBlock title={salaryError} />;
    }

    return (
        <DashboardCollapse
            header={
                <FlexContainer
                    width="100%"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <PrimaryText>До виплати:</PrimaryText>

                    <StyledSalaryAmount fontWeight="500" fontSize={16}>
                        {formatUAHStandard(salary?.total ?? 0)}
                    </StyledSalaryAmount>
                </FlexContainer>
            }
            items={salaryDetails}
        />
    );
};
